import styled from "styled-components";

export const Container = styled.div`
  width: 95vw;
  max-height: 75vh;
  overflow-y: auto;
  position: relative;
  border-radius: 10px;
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: ${({theme}) => theme["container"]};
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: ${({theme}) => theme["line"]};
  }

  ${({theme}) => theme.breakpoints.up("sm")} {
    max-height: 85vh;
    width: 590px;
  }
`;

export const Grid = styled.div`
  gap: 1rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
